module.exports = __webpack_public_path__ + "img/SKWINKELNetActieInschrijvenCA526C.b2bac97d.png";